/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the linked unresolved record
 * @export
 */
export const UnresolvedVendorErrorCodeStatus = {
    Open: 'OPEN',
    InReview: 'IN_REVIEW',
    Resolved: 'RESOLVED',
    Ignored: 'IGNORED'
} as const;
export type UnresolvedVendorErrorCodeStatus = typeof UnresolvedVendorErrorCodeStatus[keyof typeof UnresolvedVendorErrorCodeStatus];


export function instanceOfUnresolvedVendorErrorCodeStatus(value: any): boolean {
    for (const key in UnresolvedVendorErrorCodeStatus) {
        if (Object.prototype.hasOwnProperty.call(UnresolvedVendorErrorCodeStatus, key)) {
            if (UnresolvedVendorErrorCodeStatus[key as keyof typeof UnresolvedVendorErrorCodeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UnresolvedVendorErrorCodeStatusFromJSON(json: any): UnresolvedVendorErrorCodeStatus {
    return UnresolvedVendorErrorCodeStatusFromJSONTyped(json, false);
}

export function UnresolvedVendorErrorCodeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnresolvedVendorErrorCodeStatus {
    return json as UnresolvedVendorErrorCodeStatus;
}

export function UnresolvedVendorErrorCodeStatusToJSON(value?: UnresolvedVendorErrorCodeStatus | null): any {
    return value as any;
}

export function UnresolvedVendorErrorCodeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): UnresolvedVendorErrorCodeStatus {
    return value as UnresolvedVendorErrorCodeStatus;
}

